

import React from 'react';

function TermsOfServicePage() {
    return (
        <div className="privacy-policy-page" >
            <h1 className="legal-header">Privacy Policy for Arillian Farm</h1>
            {
                <h4>
                    Terms of Service for Arillian Farm

                    Last Updated: April 13, 2025

                    Welcome to Arillian Farm (the "Site," "we," "us," or "our") located at arillianfarm.com. By accessing or using our Site, you (the "User" or "you") agree to be bound by these Terms of Service (the "Terms"). Please read these Terms carefully before using our Site.

                    1. Acceptance of Terms

                    By accessing or using the Site, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, you should not access or use the Site.

                    2. Description of Service

                    Arillian Farm is a website that provides content related to [mention the main topics of Arillian Farm, e.g., recipes, videos, pictures, DIY projects, blog posts, information about books, etc.]. We may update, modify, suspend, or discontinue any part of the Site at any time without notice.

                    3. User Conduct

                    You agree to use the Site only for lawful purposes and in a manner that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the Site. Prohibited conduct includes, but is not limited to:

                    * Posting or transmitting any content that is unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful, or racially, ethnically, or otherwise objectionable.
                    * Impersonating any person or entity or falsely stating or otherwise misrepresenting your affiliation with a person or entity.
                    * Interfering with or disrupting the operation of the Site or the servers or networks used to make the Site available.
                    * Attempting to gain unauthorized access to any portion of the Site or any systems or networks connected to the Site.
                    * Engaging in any form of spamming or unsolicited advertising.
                    * Collecting or storing personal data about other users without their express consent.

                    4. User Content

                    If you post, upload, input, provide, or submit any content to the Site (collectively, "User Content"), you grant us a non-exclusive, worldwide, royalty-free, perpetual, irrevocable, and fully sublicensable right to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, and display such User Content in any media.

                    You represent and warrant that you own or otherwise control all of the rights to the User Content that you submit and that the User Content is accurate, not misleading, and does not violate these Terms or the rights of any third party.

                    We have the right, but not the obligation, to monitor, edit, or remove any User Content that we believe violates these Terms or is otherwise objectionable.

                    5. Intellectual Property

                    The content, features, and functionality offered on the Site, including but not limited to text, graphics, logos, images, videos, and software, are owned by Arillian Farm or its licensors and are protected by copyright, trademark, and other intellectual property laws.

                    You may access and view the content on the Site for your personal, non-commercial use only. You may not modify, reproduce, distribute, create derivative works of, publicly display, or in any way exploit any of the content on the Site without the prior written consent of Arillian Farm.

                    6. Links to Third-Party Websites

                    The Site may contain links to third-party websites that are not owned or controlled by Arillian Farm. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites. You acknowledge and agree that Arillian Farm shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any content, goods, or services available on or through any third-party websites.

                    7. Disclaimer of Warranties

                    THE SITE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR COURSE OF PERFORMANCE.

                    ARILLIAN FARM DOES NOT WARRANT THAT THE SITE WILL BE UNINTERRUPTED, ERROR-FREE, SECURE, OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.

                    8. Limitation of Liability

                    TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL ARILLIAN FARM, ITS AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUPPLIERS, OR LICENSORS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES) ARISING OUT OF OR RELATING TO YOUR ACCESS TO OR USE OF, OR INABILITY TO ACCESS OR USE, THE SITE.

                    9. Indemnification

                    You agree to indemnify, defend, and hold harmless Arillian Farm, its affiliates, officers, directors, employees, agents, suppliers, and licensors from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your User Content, your use of the Site, your breach of these Terms, or your violation of any rights of another party.

                    10. Governing Law

                    These Terms shall be governed by and construed in accordance with the laws of the State of [Your State/Jurisdiction], without regard to its conflict of law provisions.

                    11. Changes to These Terms

                    We may revise these Terms at any time without notice. By continuing to access or use the Site after any revisions become effective, you agree to be bound by the revised Terms. It is your responsibility to review these Terms periodically.

                    12. Contact Us

                    If you have any questions about these Terms of Service, please contact us at:

                   arillianfarm@gmail.com

                </h4>
            }
        </div>
    );
}

export default TermsOfServicePage;